import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

type updateMoveShapesType = {
  move_id: number | string;
  shapes: Array<any>;
};

export default function useUpdateMoveShapes() {
  return useMutation(async (payload: updateMoveShapesType) => {
    const response = await ChessRestClient.post(
      `learning/study_games_moves/update_shapes/`,
      payload,
    );
    return response.data;
  });
}
